import to from "await-to-js";
import { Manifest } from "../../android/components/Manifest";
import { runPermissionGroup } from "../../android/components/permissionGroupCreator";
import { createDefaultWindowConf, createWindowConfCopy } from "../../android/win/WindowConf";
import { WebViewJs } from "../../android/WebViewJs";
import { env } from "../../confs/env";
import { Log } from "@fanfanlo";
import _ from "lodash";

const fileLog = new Log(false, 'acceccibility-info-buttons');

function createCopy(callbackEventType:string, windowId:string){
    let windowConf = createDefaultWindowConf();
    const conf = {
        htmlConf:{
            // url:`${env.htmlOrigin}pages/accessibility-info-buttons/#/`,
            url:`${env.htmlOrigin}pages/accessibility-info-buttons/index.html`,
            webViewJsParams:{
                fitContentClass:"webviewMeatureContainer",
                // fitContentWidth:-200,
                // fitContentHeight:-200,
                javaToJsDataString:JSON.stringify({event:callbackEventType})
            }
        },windowId
    }
    windowConf = _.merge(windowConf, conf);
    return createWindowConfCopy(windowConf)
}

export function openHtmlShowA11yNodeInfoWindow(callbackEventType:string, windowId:string){
    const fnLog = fileLog.sub(false, 'openHtmlShowA11yNodeInfoWindow_fn');
    fnLog.info('callbackEventType =', callbackEventType, 'windowId =', windowId)
    let conf = createCopy(callbackEventType, windowId);
    fnLog.info("conf =", conf);
    return WebViewJs.instance.createWindow(JSON.stringify(conf))
}
export async function openHtmlShowA11yNodeInfoButton(callbackEventType:string, windowId:string){
    let [err, group] = await to(runPermissionGroup(Manifest.Permission.SYSTEM_ALERT_WINDOW,
        Manifest.Permission.BIND_ACCESSIBILITY_SERVICE));
        console.log('openHtmlShowA11yNodeInfoButton_fn group=', group, 'err=', err);
    if(err){
        if("message" in err){
            alert(`悬浮窗权限申请错误 message= ${err.message}`)
        }else{
            try{

                alert(`悬浮窗权限申请错误 err= ${JSON.stringify(err)}`)
            }catch(err){
                
                alert(`悬浮窗权限申请错误 stringify err ${err}`)
            }
        }
        // alert(`openHtmlShowA11yNodeInfoButton_fn error err.toString()`)
        WebViewJs.instance.toast(err.toString())
        // showSimpleToast(err.toString())
        return;
    }
    return openHtmlShowA11yNodeInfoWindow(callbackEventType, windowId);
}